require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-uvp-7-f.json") })
        }
      }, "path---photos-professional-uvp-7-f");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-uvp-7-f!./.cache/json/photos-professional-uvp-7-f.json
// module id = 923
// module chunks = 231608221292675